import React, { useState, useRef } from "react";
import Slider from 'react-slick'
import { Link } from "react-router-dom";
import Detail_1 from '../../../assets/images/home_page_4/product/09.png'
import Detail_2 from '../../../assets/images/home_page_4/product/04.png'
import Detail_3 from '../../../assets/images/home_page_4/product/13.png'
import Detail_4 from '../../../assets/images/home_page_4/product/14.png'
import Pro05 from '../../../assets/images/home_page_4/product/05.png'
import Pro09large from '../../../assets/images/home_page_4/product/09_large.png'
import Pro04large from '../../../assets/images/home_page_4/product/04_large.png'
import Pro13large from '../../../assets/images/home_page_4/product/13_large.png'
import Pro14large from '../../../assets/images/home_page_4/product/14_large.png'
import Pro05large from '../../../assets/images/home_page_4/product/05_large.png'

const sattings = {
    slidesToShow: 1,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
            }
        },
        {
            breakpoint: 740,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
            }
        }
    ]
}

const sattings2 = {
    slidesToShow: 5,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
            }
        },
        {
            breakpoint: 740,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
            }
        }
    ]
}


const ShopDetails = () => {

    const [nav1, setNav1] = useState(null);
    const [nav2, setNav2] = useState(null);
    const slider1 = useRef(null);
    const slider2 = useRef(null);

    const [quantity, setQuantity] = useState(1);

    const handleIncrement = () => {
        if (quantity < 100) {
            setQuantity(quantity + 1);
        }
    };

    const handleDecrement = () => {
        if (quantity > 0) {
            setQuantity(quantity - 1);
        }
    };


    const handleChange = (e) => {
        const value = Math.max(0, Math.min(10, e.target.value));
        setQuantity(value);
    };



    return (
        <>
            <section id="product-dtl" className="product-dtl-main-block">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-5 col-md-6">
                            <Slider className="slider shop-slider-for" {...sattings} asNavFor={nav2}
                                ref={(slider) => setNav1(slider)}>
                                <div>
                                    <div className="shop-slider-zoom-img">
                                        <img
                                            className="demo-trigger"
                                            src={Pro09large}
                                            data-zoom={Pro09large}
                                            alt=""
                                        />
                                    </div>
                                </div>
                                <div>
                                    <div className="shop-slider-zoom-img">
                                        <img
                                            className="demo-trigger"
                                            src={Pro04large}
                                            data-zoom={Pro04large}
                                            alt=""
                                        />
                                    </div>
                                </div>
                                <div>
                                    <div className="shop-slider-zoom-img">
                                        <img
                                            className="demo-trigger"
                                            src={Pro13large}
                                            data-zoom={Pro13large}
                                            alt=""
                                        />
                                    </div>
                                </div>
                                <div>
                                    <div className="shop-slider-zoom-img">
                                        <img
                                            className="demo-trigger"
                                            src={Pro14large}
                                            data-zoom={Pro14large}
                                            alt=""
                                        />
                                    </div>
                                </div>
                                <div>
                                    <div className="shop-slider-zoom-img">
                                        <img
                                            className="demo-trigger"
                                            src={Pro05large}
                                            data-zoom={Pro05large}
                                            alt=""
                                        />
                                    </div>
                                </div>
                                <div>
                                    <div className="shop-slider-zoom-img">
                                        <img
                                            className="demo-trigger"
                                            src={Pro09large}
                                            data-zoom={Pro09large}
                                            alt=""
                                        />
                                    </div>
                                </div>
                                <div>
                                    <div className="shop-slider-zoom-img">
                                        <img
                                            className="demo-trigger"
                                            src={Pro04large}
                                            data-zoom={Pro04large}
                                            alt=""
                                        />
                                    </div>

                                </div>
                            </Slider>
                            <Slider className="slider shop-slider-nav"{...sattings2} asNavFor={nav1}
                                ref={(slider) => setNav2(slider)} focusOnSelect={true}>
                                <div>
                                    <img
                                        src={Detail_1}
                                        className="img-fluid"
                                        alt=""
                                    />
                                </div>
                                <div>
                                    <img
                                        src={Detail_2}
                                        className="img-fluid"
                                        alt=""
                                    />
                                </div>
                                <div>
                                    <img
                                        src={Detail_3}
                                        className="img-fluid"
                                        alt=""
                                    />
                                </div>
                                <div>
                                    <img
                                        src={Detail_4}
                                        className="img-fluid"
                                        alt=""
                                    />
                                </div>
                                <div>
                                    <img
                                        src={Pro05}
                                        className="img-fluid"
                                        alt=""
                                    />
                                </div>
                                <div>
                                    <img
                                        src={Detail_1}
                                        className="img-fluid"
                                        alt=""
                                    />
                                </div>
                                <div>
                                    <img
                                        src={Detail_2}
                                        className="img-fluid"
                                        alt=""
                                    />
                                </div>
                            </Slider>
                        </div>
                        <div className="col-lg-7 col-md-6">
                            <div className="product-detail-block">
                                <h2 className="product-dtl-title">Powering Your Mobile Experience</h2>
                                <p>
                                    Web designing in a powerful way of just not an only professi
                                    however, in a pass Company We have a to a tendency
                                </p>
                                <ul className="d-flex product-star-rating">
                                    <li className="icons">
                                        <i className="flaticon-star star-yellow" />
                                    </li>
                                    <li className="icons">
                                        <i className="flaticon-star star-yellow" />
                                    </li>
                                    <li className="icons">
                                        <i className="flaticon-star star-yellow" />
                                    </li>
                                    <li className="icons">
                                        <i className="flaticon-star star-yellow" />
                                    </li>
                                    <li className="icons">
                                        <i className="flaticon-star star-grey" />
                                    </li>
                                </ul>
                                <div className="cust-rat-review">1 Customer Review</div>
                                <div className="price">
                                    $32.00 <s>$</s>
                                    <s>25.00</s>
                                </div>
                                <ul className="product-dtl-list">
                                    <li>6.4Inch display toch sceen (1920x1180)</li>
                                    <li>50Mp Font Camera Back Camera 108Mp</li>
                                    <li>6000Mh Battry With Fast Chager</li>
                                </ul>
                                <div className="qty-input">
                                    <button
                                        className="qty-count qty-count--minus"
                                        onClick={handleDecrement}
                                        type="button"
                                    >
                                        -
                                    </button>
                                    <input
                                        className="product-qty"
                                        type="number"
                                        name="product-qty"
                                        min={0}
                                        max={10}
                                        value={quantity}
                                        onChange={handleChange}
                                    />
                                    <button
                                        className="qty-count qty-count--add"
                                        onClick={handleIncrement}
                                        type="button"
                                    >
                                        +
                                    </button>
                                </div>
                                <div className="product-dtl-cart-btn">
                                    <Link to="#" title="" className="btn btn-primary">
                                        Add to Cart
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default ShopDetails
